import React from 'react';

const CanselVoice = () => {
    return (
        <svg width={9.828} height={9.828} viewBox="0 0 9.828 9.828">
            <path
                d="M8.414 1.414l-7 7M1.414 1.414l7 7"
                fill="none"
                stroke="#8F99DC"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
            />
        </svg>
    );
};

export default CanselVoice;
